import HelpBox from "../../shared/content/HelpBox";

export default function RiskManagementProcessPolicySupplementaryHelp() {
  return (
    <HelpBox>
      <HelpBox.Header>Risk Management Process and Policy - Supplementary Data Help</HelpBox.Header>
      <HelpBox.Content>
        <p>
          This form allows you to collate records on supplementary information required on Risk Management Processes and Policies.
        </p>
        <p>After creating the eight required Risk Management Processes and Policies records, complete this form to provide supplementary data.</p>
        <ol type="1">
          <li>
            Enter data in each of the fields provided.
          </li>
          <li>
            You should also attach evidence supporting this record, using the <i>Evidence Attachments</i> form. You can create a new evidence record by clicking the <b>New</b> button then fill in the required fields.
          </li>
          <li>
            Finally click the <b>Submit</b> or <b>Update</b> buttons.
          </li>
        </ol>
      </HelpBox.Content>
    </HelpBox>
  );
}
